import { decorate, injectable, inject } from 'inversify';

const defineService = (service, dependencies) => {
  decorate(injectable(), service);

  if (!dependencies) {
    return;
  }

  dependencies.forEach(((dependency, index) => {
    decorate(inject(dependency), service, index);
  }));
};

export default defineService;



// WEBPACK FOOTER //
// ./src/utils/di.js